import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconeServicoComponent } from '../../../../shared/components/icone-servico/icone-servico.component';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import {
  CATEGORIA_SERVICOS_TIPOS,
  CategoriaServicosItem,
} from '../../models/categoria-servicos.model';

@Component({
  selector: 'app-page-categoria-servicos-card',
  templateUrl: './page-categoria-servicos-card.component.html',
  imports: [IconeServicoComponent, RouterLink, LucideModule],
})
export class PageCategoriaServicosCardComponent {
  readonly categoria = input.required<CategoriaServicosItem>();

  readonly tipos = computed(() =>
    CATEGORIA_SERVICOS_TIPOS.filter((opcao) => this.categoria().tipos.includes(opcao.tipo))
  );
}
